import { Environment } from './environment.interface';

// Ambiente DEVELOPMENT: https://dev-reclutamiento2027.ieeg.mx
//
// apiUrl apunta al dominio propio, no a la URL cruda de API Gateway: el id de
// execute-api cambia cada vez que se recrea el stack, el dominio no.
export const environment: Environment = {
  name: 'development',
  production: true,
  apiUrl: 'https://api.dev-reclutamiento2027.ieeg.mx',
  urlDataBucket: 'https://s3.amazonaws.com/data.dev-reclutamiento.ieeg.mx/',
  apiGlobalUrl: 'https://api.global.ieeg.mx/',

  // Login Azure
  authorityAzure: 'https://login.microsoftonline.com/6d88d07c-1672-4d16-ab8c-3af2ef736fe7',
  clientIdAzure: 'ae04b56b-8154-4a59-aac8-8ead60472bd2',
  meAzure: 'https://graph.microsoft.com/v1.0/me',
  redirectAplicationAzure: 'https://dev-reclutamiento2027.ieeg.mx',
  scopesAzure: 'api://a9333b79-0578-4377-80d6-f69af15b23ab/Auth.AD',
};
